export default {
  img: {
    objectFit: 'contain'
  }
}
